export default __webpack_public_path__ + "static/7b16716e91a4f637809534ad1b804beb.jpg";